import React from 'react';

/**
 * Blue Map Pin Icon
 * @returns SVG
 */
export const MapPinIcon: React.VFC = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="icon selection">
            <path
                id="primary fill"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0671 4C8.9342 4 6.40039 6.504 6.40039 9.6C6.40039 13.8 12.0671 20 12.0671 20C12.0671 20 17.7337 13.8 17.7337 9.6C17.7337 6.504 15.1999 4 12.0671 4ZM12.0668 11.5996C10.9496 11.5996 10.043 10.7036 10.043 9.59961C10.043 8.49561 10.9496 7.59961 12.0668 7.59961C13.1839 7.59961 14.0906 8.49561 14.0906 9.59961C14.0906 10.7036 13.1839 11.5996 12.0668 11.5996Z"
                fill="#044F60"
            />
        </g>
    </svg>
);
